import React, { useEffect, useState } from "react";
import TablePaginationComponents from "../WebPages/components/TablePaginationComponents";
import {
  getHistory,
  serviceFetchFailedLogs,
  get_link,
} from "../Services/Service";
import { ModalBox, CustomLoader } from "../Services/CommonLibrary";

function History() {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    total_records: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    previous_page: null,
    next_page: null,
  });
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState("");

  useEffect(() => {
    loadData();
  }, [pagination.current_page, pagination.per_page]);

  /** Fetch API */
  const loadData = async () => {
    setLoading(true);
    try {
      const res = await getHistory(
        pagination.current_page,
        pagination.per_page
      );

      setData(res?.data?.data?.records ?? []);
      setPagination(res?.data?.data?.pagination ?? pagination);
    } catch (error) {
      console.error(error);
      setData([]);
    }
    setLoading(false);
  };

  /** Columns */
  const columns = [
    {
      label: "#",
      render: (_, index) =>
        (pagination.current_page - 1) * pagination.per_page + index + 1,
    },
    { label: "Document ID", key: "uploadUniqueId" },
    { label: "Uploaded By", key: "uplodedBy" },
    { label: "Created On", key: "createdTime" },
    {
      label: "Account Created",
      render: (r) =>
        r.preupload != 1 && r.textuploadpre != 1 ? r.successCount : 0,
    },
    {
      label: "Valid Data",
      render: (r) =>
        r.preupload == 1 || r.textuploadpre == 1 ? r.successCount : 0,
    },
    {
      label: "Invalid Data",
      render: (r) => (
        <span
          onClick={() => fetchFailedLogs(r.uploadUniqueId)}
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            color: "#ff3b00",
            fontWeight: "bold",
          }}
        >
          {r.failCount}
        </span>
      ),
    },
    { label: "Total", key: "total" },
  ];

  /** ACTION BUTTONS */
  const renderActions = (row) => (
    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() => redirectToDownload(row.fileurl, row.id)}
    >
      <i className="bi bi-download"></i>
    </button>
  );

  /** Download */
  const redirectToDownload = async (link, id) => {
    try {
      const response = await get_link(id, "history");

      if (response?.data?.code === 200) {
        link = response.data.data.compositionUrl;
      }

      window.open(link.replace(/"/g, ""), "_blank");
    } catch (error) {
      console.error(error);
    }
  };

  /** Fetch Failed Logs */
  const fetchFailedLogs = async (docId) => {
    setShowModal(true);
    try {
      const res = await serviceFetchFailedLogs(docId);

      const modalBodyComponent =
        res.data.status == 1 ? (
          res.data.data.map((item, i) => (
            <tr key={i}>
              <td>
                <span
                  style={
                    item.status == "Success"
                      ? { color: "green" }
                      : { color: "red" }
                  }
                >
                  {item.preupload == 1 || item.textuploadpre == 1
                    ? item.status == "Success"
                      ? "Valid Data"
                      : "Invalid Data"
                    : item.status == "Success"
                    ? "Account created"
                    : "Invalid Data"}
                </span>
              </td>
              <td>
                {item.statusMsg.split(",").map((line, index) => (
                  <span
                    key={index}
                    style={
                      item.statusMsg == "Success"
                        ? { color: "green" }
                        : { color: "red" }
                    }
                  >
                    {index === 0 ? line : [<br key={index} />, line]}
                  </span>
                ))}
              </td>

              {item.rawJson.map((dataItem, x) =>
                item.textuploadpre == 1 ? (
                  x <= 7 ? <td key={x}>{dataItem}</td> : null
                ) : (
                  <td key={x}>{dataItem}</td>
                )
              )}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="2">No Records</td>
          </tr>
        );

      const html = (
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Status</th>
                <th>Reason</th>
                <th>Practice Name</th>
                <th>Doctor email</th>
                <th>NHS number</th>
                <th>Patient Name</th>
                <th>Patient Email</th>
                <th>Patient Mobile</th>
                <th>Program Name</th>
                <th>Division</th>
              </tr>
            </thead>
            <tbody>{modalBodyComponent}</tbody>
          </table>
        </div>
      );

      setModalBody(html);
    } catch (error) {
      console.error("Error fetching failed logs:", error);
    }
  };

  return (
    <section>
      <TablePaginationComponents
        columns={columns}
        data={data}
        loading={loading}
        pagination={pagination} // <-- IMPORTANT
        onPageChange={(page) =>
          setPagination((prev) => ({ ...prev, current_page: page }))
        }
        onRowsPerPageChange={(n) =>
          setPagination((prev) => ({
            ...prev,
            per_page: n,
            current_page: 1,
          }))
        }
        renderActions={renderActions}
      />

      {showModal && (
        <ModalBox
          showModaln={showModal}
          handleClose={() => setShowModal(false)}
          titlen="Failed Logs"
          bodyn={modalBody}
        />
      )}
    </section>
  );
}

export default History;
